import KUSubmitData from './KUSubmitData'

export default KUSubmitData
